import dayjs from "dayjs";
import PropTypes from "prop-types";

import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";

import { formatDate, formatDateTime } from "../../features/shared";

const styles = StyleSheet.create({
  page: {
    padding: 24,
    fontSize: 10,
    fontFamily: "Helvetica",
  },
  header: {
    fontSize: 20,
    fontFamily: "Helvetica-Bold",
    color: "#364F6B",
  },
  sectionTitle: {
    fontSize: 13,
    fontFamily: "Helvetica-Bold",
    color: "#364F6B",
    marginTop: 16,
    marginBottom: 12,
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#ececec",
    fontFamily: "Helvetica-Bold",
    paddingHorizontal: 8,
    paddingVertical: 2,
  },
  tableRow: {
    flexDirection: "row",
    borderColor: "#ececec",
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    paddingHorizontal: 8,
    paddingVertical: 2,
  },
  cell: {
    padding: 4,
  },
  attributeHeader: {
    fontSize: 10,
    fontFamily: "Helvetica-Bold",
    marginTop: 8,
  },
});

export const SalesOrderProductVariantHubPdf = ({
  data,
  user,
  outlet,
  dateRange,
}) => {
  const [startDate, endDate] = dateRange;
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-end",
            marginBottom: 16,
          }}
        >
          <Text style={styles.header}>Penjualan Per Cabang Pembeli</Text>
          <Text
            style={{
              fontSize: 12,
              color: "#364F6B",
              fontFamily: "Helvetica-Bold",
            }}
          >
            {outlet.name}
          </Text>
        </View>

        {/* Information Section */}
        <View style={{ flexDirection: "row", marginVertical: 16 }}>
          <View style={{ flex: 1 }}>
            <Text>Tanggal Download</Text>
            <Text style={styles.attributeHeader}>
              {formatDateTime(dayjs())}
            </Text>
          </View>
          <View style={{ flex: 1 }}>
            <Text>Didownload Oleh</Text>
            <Text style={styles.attributeHeader}>{user.name}</Text>
          </View>
          <View style={{ flex: 1 }}>
            <Text>Dari Tanggal - Sampai Tanggal</Text>
            <Text style={styles.attributeHeader}>
              {`${formatDate(startDate)} - ${formatDate(endDate)}`}
            </Text>
          </View>
        </View>

        {/* Buyer Outlet Groups */}
        {data.map(({ buyerOutlet, productVariants }) => (
          <View key={buyerOutlet.id}>
            <View wrap={false}>
              <Text style={styles.sectionTitle}>{buyerOutlet.name}</Text>
              <View style={styles.tableHeader}>
                <Text style={[styles.cell, { flex: 3 }]}>SKU</Text>
                <Text style={[styles.cell, { flex: 3 }]}>Nama Barang</Text>
                <Text style={[styles.cell, { flex: 1, textAlign: "right" }]}>
                  Qty
                </Text>
              </View>
            </View>
            {productVariants.map((productVariant) => (
              <View
                style={styles.tableRow}
                key={productVariant.sku}
                wrap={false}
              >
                <Text style={[styles.cell, { flex: 3 }]}>
                  {productVariant.sku}
                </Text>
                <Text style={[styles.cell, { flex: 3 }]}>
                  {productVariant.name}
                </Text>
                <Text style={[styles.cell, { flex: 1, textAlign: "right" }]}>
                  {productVariant.quantity}
                </Text>
              </View>
            ))}
          </View>
        ))}
      </Page>
    </Document>
  );
};

SalesOrderProductVariantHubPdf.propTypes = {
  data: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
  outlet: PropTypes.object.isRequired,
  dateRange: PropTypes.array.isRequired,
};
